import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./auth";
import { useDispatch } from "react-redux";
import toastReducer from "./toast/toastslice";
import itinFormReducer from "./itinForm/index";
import itinReducer from "./itin/index";
import { incorporationSlice } from "./incorporation";
import { adminSlice } from "./admin";
import { agentSlice } from "./agents";
import { clientSlice } from "./clients";
import { orderSlice } from "./orders";
import { serviceSlice } from "./services";
import { taxFilingSlice } from "./taxfiling";
import { bppSlice } from "./bpp";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    toast: toastReducer,
    itinForm: itinFormReducer,
    itin: itinReducer,
    incorporation: incorporationSlice.reducer,
    admin: adminSlice.reducer,
    agents: agentSlice.reducer,
    clients: clientSlice.reducer,
    orders: orderSlice.reducer,
    services: serviceSlice.reducer,
    taxfiling: taxFilingSlice.reducer,
    bpp:bppSlice.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
